import React from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';

export default function EmptyState({ queueCount, ticketsCount }) {
  const getMessage = () => {
    if (queueCount > 0) {
      return 'Selecione um atendimento da fila para começar.';
    }
    if (ticketsCount > 0) {
      return 'Selecione um dos seus atendimentos ativos.';
    }
    return 'Nenhum atendimento no momento. Novos chamados aparecerão automaticamente.';
  };

  return (
    <Card
      className="card new-layout mb-0 h-100"
      style={{ border: '0.5px solid #dee2e6' }}
    >
      <CardBody className="d-flex align-items-center justify-content-center h-100">
        <Row className="w-100 mx-0">
          <Col className="text-center">
            <i
              className="fab fa-whatsapp d-block mb-3"
              style={{ fontSize: '40px', color: '#60b05d' }}
            />
            <div className="font-size-16 font-weight-600 text-gray-600">
              {getMessage()}
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
